export const isProdEnv =
  window.location.hostname === "www.skanskabyggvaror.se" ||
  window.location.hostname === "www.grontfokus.no" ||
  window.location.hostname === "www.nordrum.com";
